import React from 'react';
import { useHistory } from 'react-router';
import { FileProfileIcon } from '../Icons/Icons';

import './registershortcut.scss';


export default function RegisterShortcut () {
	const history = useHistory();

	function handleOnClick () {
		window.scrollTo(0, 0);
		history.push('/registration');
	}

	return (
		<div className="register-shortcut-btn d-flex d-md-none" onClick={handleOnClick}>
			<FileProfileIcon/>
		</div>
	)
}